import { defineStore } from 'pinia'
import { useStorage } from '@vueuse/core'

const COOKIEHUB_COOKIE_NAME = 'cookiehub'

function readRawCookie(name) {
    const match = document.cookie
        .split('; ')
        .find((row) => row.startsWith(`${encodeURIComponent(name)}=`) || row.startsWith(`${name}=`))
    if (!match) return null
    try {
        return decodeURIComponent(match.split('=').slice(1).join('='))
    } catch {
        return null
    }
}

function tryParseJSON(value) {
    try {
        return JSON.parse(value)
    } catch {
        return null
    }
}

function tryParseBase64JSON(value) {
    try {
        return JSON.parse(atob(value))
    } catch {
        return null
    }
}

function parseCookieHubCookie() {
    const raw = readRawCookie(COOKIEHUB_COOKIE_NAME)
    if (!raw) return null

    const parsed = tryParseJSON(raw) || tryParseBase64JSON(raw)
    if (!parsed || typeof parsed !== 'object') return null

    if (parsed.answered !== true) return null
    if (parsed.allAllowed !== true) return null

    return { analytics: true, marketing: true }
}

export const useConsentStore = defineStore('consent', {
    state: () => ({
        analytics: useStorage('consent_v1_analytics', false),
        marketing: useStorage('consent_v1_marketing', false),
        decided: useStorage('consent_v1_decided', false),
        source: useStorage('consent_v1_source', null),
    }),

    getters: {
        necessary: () => true,
        needsPrompt: (state) => !state.decided,
        analyticsGranted: (state) => state.decided && state.analytics === true,
        marketingGranted: (state) => state.decided && state.marketing === true,
    },

    actions: {
        hydrate() {
            if (this.decided) return

            const inherited = parseCookieHubCookie()
            if (inherited) {
                this.analytics = inherited.analytics
                this.marketing = inherited.marketing
                this.decided = true
                this.source = 'cookiehub'
            }
        },

        acceptAll() {
            this.analytics = true
            this.marketing = true
            this.decided = true
            this.source = 'platform'
        },

        rejectAll() {
            this.analytics = false
            this.marketing = false
            this.decided = true
            this.source = 'platform'
        },

        save({ analytics, marketing }) {
            this.analytics = !!analytics
            this.marketing = !!marketing
            this.decided = true
            this.source = 'platform'
        },

        reset() {
            this.analytics = false
            this.marketing = false
            this.decided = false
            this.source = null
        },
    },
})
